<template>
    <div class="details-text-container position-relative">
        <div class="px-2 px-lg-5 px-md-5">
            <div class="desktop-desc">
                <p class="fs-2">{{ title }}</p>
    
                <div class="fs-5 mb-4" v-if="total.discountedPrice > 0" :class="{ 'apply-shake': shake }">
                    From {{ itemCurrency }}
                    <del style="color: #ea1a21">
                        <strong style="color: #212529">
                            {{ total.salesPrice.toLocaleString() }}</strong> </del>&nbsp;
                    <strong style="color: #ea1a21">
                        {{ Math.ceil(total.discountedPrice).toLocaleString() }} &nbsp;
                    </strong>
                </div>
                <div class="fs-5 mb-4" :class="{ 'apply-shake': shake }" v-else>
                    From {{ itemCurrency }} <strong>{{ Math.ceil(total.salesPrice).toLocaleString() }}</strong>
                </div>
                <div class="fs-6 mb-4" v-html="articles"></div>
    
                <p class="fs-6 mb-4">As low as {{ itemCurrency }} <strong>{{ convertPrice(emiPrice) }}</strong> month EMI Facilities up to 12 months.
                    Purchase amount minimum BDT <strong>5000</strong>. 
                </p>
            </div>
            <p 
                class="fs-6 mb-4 fw-semibold text-decoration-underline cursor-pointer" 
                @click.prevent="emiModalVisibility = true"
            >
                EMI Bank Details
            </p>
            
            <hr class="border-2 m-0" />
            <div class="accordion accordion-flush desktop-hidden" id="accordionFlushExample" style="z-index: 0;">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingOne">
                        <button class="accordion-button collapsed ps-0" type="button" data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                            <p>DETAILS</p>
                        </button>
                    </h2>
                    <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne"
                        data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body ps-0" style="max-height: 30vh; height: 30vh; overflow: hidden scroll;">
                            <div class="statement-list row p-0 pe-3">
                                <div class="col-12 p-0">
                                    <ul class="p-0">
                                        <li v-for="(item, index) in details" :key="index" style="margin: 10px 26px;">
                                            {{ item.points }}
                                        </li>
                                    </ul>
                                    <table class="table" v-if="dimensions.length" style="margin: 10px 15px;">
                                        <tbody style="margin: 10px 15px;">
                                            <tr v-for="(item, i) in dimensions" :key="i">
                                                <td> {{ item.field }} </td>:
                                                <td> {{ item.value }} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingTwo">
                        <button class="accordion-button collapsed ps-0" type="button" data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                            <p>DIMENSIONS</p>
                        </button>
                    </h2>
                    <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo"
                        data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body table-responsive" style="max-height: 30vh; height: 30vh;">
                            <carousel style="width: 100%;" ref="myCarousel" :settings="settings"
                                class="product_slider h-100" :wrap-around="true" v-if="dimensionsImages.length">
                                <template #slides>
                                    <slide v-for="(img, i) in dimensionsImages" :key="i">
                                        <div class="dimensions-left-section bg-image w-100 h-100 cursor-pointer" :style="{ backgroundImage: `url(${img})` }" @click="imgZoomModalVisibility = true"></div>
                                    </slide>
                                </template>

                                <template #addons>
                                    <Pagination />
                                </template>
                            </carousel>
                            <p v-else class="h-100 d-flex justify-content-center align-items-center">No Dimensions Available</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingThree">
                        <button class="accordion-button collapsed ps-0" type="button" data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                            <p>HOW TO CARE</p>
                        </button>
                    </h2>
                    <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree"
                        data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body ps-0" style="max-height: 30vh; height: 30vh; overflow: hidden scroll;">
                            <div class="statement-list row p-0 pe-3">
                                <div class="fs-6 mb-4 p-0" style="margin: 10px 15px;" v-html="howToCare"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingFour">
                        <button class="accordion-button collapsed ps-0" type="button" data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                            <p>PREDICTED DELIVERY TIME</p>
                        </button>
                    </h2>
                    <div id="flush-collapseFour" class="accordion-collapse collapse" aria-labelledby="flush-headingFour"
                        data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body p-0" style="max-height: 30vh; height: 30vh; overflow: hidden scroll;">
                            <div class="statement-list row p-0 ps-3 pb-3">
                               
                                <p class=" p-0 my-0">
                                    <p>Select Your Location</p>
                                </p>
                                <SelectDesign
                                    label=""
                                    bgColor="#F9F7F3"
                                    v-model="selectedDivision"
                                    :list="tabTitle"
                                    class="p-0 w-50"
                                />
                                <p class=" p-0 pt-1 my-0">
                                    <p>Nearest Showroom</p>
                                </p>
                                <SelectDesign
                                    label=""
                                    bgColor="#F9F7F3"
                                    v-model="selectedOutlet"
                                    :list="divisionsOutlets"
                                    class="p-0 w-50"
                                />
                                <p class=" p-0 pt-1 my-0">
                                    <p>Est. Date <small>(Calculation starts from order confirmation date)</small></p>
                                </p>

                                <SelectedInput
                                    label=""
                                    bgColor="#F9F7F3"
                                    class="p-0 w-50"
                                    style="margin-top: 14px !important"
                                    :item="convertDate"
                                    textClass=""
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transition name="slide-right">
            <div class="position-absolute top-0 h-100 shadow-lg special-fabric p-4" v-if="specialFabric"
                v-click-outside="onOutsideClick">
                <p class="fs-5">127 SPECIAL ORDER FABRICS</p>
                <p class="fs-7 mt-4">Select your dream Fabrics</p>
                <div class="row m-0 my-3 position-relative">
                    <div class="cursor-pointer special-leather col-2 p-0 py-3 pe-2" v-for="(item, i) in fabricOptions"
                        :key="i" @click.prevent="selectFabrics(item)">
                        <img :src="item.img" class="img-fluid" style="height: 100px; width: 100px;" />
                        <p class="fs-7 w-75">{{ item.name }}</p>
                    </div>
                </div>
            </div>
        </transition>

        <CommonsModalBaseModal 
            title="" 
            :show="emiModalVisibility" 
            @close="emiModalVisibility = false" 
            maxWidth="60%" 
            :modalFooter="false"
        >
            <div class="emi-modal-content">
                <div class="modal-body">
                    <div>
                        <div class="emi-wrappar pd-list">
                            <h2>
                                Select a bank to know its EMI
                                facilities
                            </h2>
                            <ul class="bankemis">
                                <li class="bank-item" v-for="(bank, i) in emiSupportBankList" :key="i"
                                    @click="changeEmiTime(bank)" :class="{
                                        active:
                                            checkedBank == bank.tag,
                                    }">
                                    <span class="stitle">
                                        {{ bank.name }}
                                    </span>
                                </li>
                            </ul>
                            <div class="emi-msg">
                                * EMI valid only for
                                <span class="emi-time">{{ emiTime }}.</span>
                                EMI Interest shown below:
                            </div>
                        </div>
                        <div class="emi-wrappar table-responsive d-flex justify-content-center"
                            v-for="(int, i) in emiSupportBankList" :key="i">
                            <table v-if="int.tag == checkedBank" class="w-100">
                                <thead>
                                    <tr>
                                        <th>EMI Tenor</th>
                                        <th>Interest Payable</th>
                                        <th>Down Payment</th>
                                        <th>EMI Amount</th>
                                        <th>Total Payment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(mt, index) in int.emiMonths" :key="index">
                                        <td>{{mt.month}} Months</td>
                                        <td>
                                            BDT 0
                                        </td>
                                        <td>
                                            BDT 0
                                        </td>
                                        <td>
                                            BDT {{ Math.ceil(total.salesPrice / mt.month).toLocaleString() }}
                                        </td>
                                        <td>
                                            BDT {{total.salesPrice.toLocaleString()}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </CommonsModalBaseModal>
        <CommonsModalBaseModal
            :show="imgZoomModalVisibility"
            @close="imgZoomModalVisibility = false"
            :modalFooter="false"
            maxWidth="50%"
            maxHeight="80vh"
            bodyStyle="padding: 0 !important"
            title=""
        >
            <ImageZoomer :images="dimensionsImages"/>
        </CommonsModalBaseModal>
    </div>
</template>

<script setup>
import { useCartStore } from "@/stores/cart.js";
import { useItemDto } from '@/composables/useItemDto';
import { useCurrenciesStore } from "@/stores/currencies-store";
import { optionsClient } from "@/assets/apis/config";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { useAuthStore } from "@/stores/auth-store";
import { useGlobalDiscountStore } from "@/stores/global-discount-store";
import divisions from '@/data/divisions.json';
import showrooms from '@/data/showrooms.json';
import { useVModel } from "@/fuel-station/useVModel";
import emiBankList from '@/data/emiBankList.json';
import ImageZoomer from "@/components/commons/nav/ImageZoomer.vue";
import { DateUtils } from "@/libs/utils/DateUtils";

const props = defineProps({
    modelValue: {
        type: [Object, Array, String],
        default: {
            id: 0,
            name: "Select One"
        },
    },
    item: {
        type: Object,
        default: null,
    },
    attributes: {
        type: Array,
        default: () => [],
    },
    details: {
        type: Object,
        default: () => [],
    },
    articles: {
        type: Object,
        default: () => [],
    },
    howToCare: {
        type: Object,
        default: () => [],
    },
});

const router = useRouter();
// const notyf = new Notyf();
const cartStore = useCartStore();
const currenciesStore = useCurrenciesStore();
const authStore = useAuthStore();
const globalDiscountStore = useGlobalDiscountStore();
const emiModalVisibility = ref(false);
const imgZoomModalVisibility = ref(false);
const checkedBank = ref("city");
const screenWidth = ref(process.client ? screen.width : 0);

const emit = defineEmits(["selectImage", "selectFinishes", 'update:modelValue']);
const itemRef = toRef(props, "item");
const selectedAttributeValues = ref([]);
const quantity = ref(1);
const discriminatorAttribute = ref([]);
const shake = ref(false);
const finishes = ref("");
const specialFabric = ref(false);
const showroomData = ref(showrooms);
const emiSupportBankList = ref(emiBankList?.emiBankList);

const selectedDivision = ref({id: "Selected-One", name: "Select One", selected: true});
const selectedOutlet = ref({id: "Selected-One", name: "Select One", selected: true});
const tabTitle = computed(() => {
    let arr = [{id: "Selected-One", name: "Select One", selected: true}];
    if (divisions.length) {
        arr = [...arr,...divisions];
    }
    return arr;
});

const divisionsOutlets = computed(() => {
    let arr = [{id: "Selected-One", name: "Select One", selected: true}];
    
    if (showroomData.value && selectedDivision.value?.name?.length) {
        let divisionName = selectedDivision.value.tabId;
        let findDivision = showroomData.value[divisionName] && showroomData.value[divisionName].length ? showroomData.value[divisionName] : [];
        if (findDivision.length) {
            arr = [{id: "Selected-One", name: "Select One", selected: true},...findDivision];
        }
    } 
    return arr;
});

const estTime = computed(() => {
    let val = "";
    if (selectedOutlet.value?.name?.length) {
        val = selectedOutlet.value.estTime;
    }
    return val;
});

const fabricOptions = ref([
    {
        img: "/images/details/f-1.png",
        name: "White",
    },
    {
        img: "/images/details/f-2.png",
        name: "White",
    },
    {
        img: "/images/details/f-3.png",
        name: "White",
    },
    {
        img: "/images/details/f-4.png",
        name: "White",
    },
    {
        img: "/images/details/f-5.png",
        name: "White",
    },
    {
        img: "/images/details/f-6.png",
        name: "White",
    },
    {
        img: "/images/details/f-7.png",
        name: "White",
    },
    {
        img: "/images/details/f-8.png",
        name: "White",
    },
    {
        img: "/images/details/f-9.png",
        name: "White",
    },
    {
        img: "/images/details/f-10.png",
        name: "White",
    },
    {
        img: "/images/details/f-11.png",
        name: "White",
    },
    {
        img: "/images/details/f-12.png",
        name: "White",
    },
    {
        img: "/images/details/f-13.png",
        name: "White",
    },
    {
        img: "/images/details/f-14.png",
        name: "White",
    },
]);

const settings = ref({
    itemsToShow: 1,
    snapAlign: "end",
});

const { id, primaryImageUrl, title, price, discountedSalesPrice, subscriptionPrice } = useItemDto(itemRef.value);

const emiTime = ref("3, 6, 9 &amp; 12 months");
const changeEmiTime = (bank) => {
    checkedBank.value = bank.tag;
    emiTime.value = bank.time;
};
const dimensions = computed(() => {
    let arr = [];

    if (props.attributes && props.attributes.length > 0) {
        let findAttribute = props.attributes.filter((i) => !i.type);
        arr = findAttribute.length > 0 ? findAttribute : [];
    }

    return arr;
});

const dimensionsImages = computed(() => {
    let arr = [];

    if (props.attributes && props.attributes.length > 0) {
        let findAttribute = props.attributes.filter((i) => i.type);
        if (findAttribute.length) {
            let image = findAttribute[0];
            Object.keys(image).forEach(key => {
                if (key != 'type' && image[key]?.length) {
                    arr.push(image[key]); 
                }
            });
        }
    }

    return arr;
});



const onOutsideClick = () => {
    specialFabric.value = false;
};

const globalDiscount = computed(() => {
    if (!props.item?.id) {
        return { discountPrice: 0, skuLabel: '' };
    }
    let discountPrice = 0;
    let matchedSkuLabel = '';
    let salesPrice = Number(price.value);
    let categoryIds = itemRef.value?.categories;
    // Use itemId or id depending on what's available
    const itemIdValue = props.item?.id || props.item?.itemId;

    if (globalDiscountStore?.discounts?.length) {
        globalDiscountStore.discounts.forEach(element => {
            let discount = element.discountType === 'PERCENTAGE' ? Math.floor(salesPrice - salesPrice * Number(element.value) / 100) : salesPrice - Number(element.value);
            
            if (element.type === 'FIXED_CATEGORY' && element.valid) {
                categoryIds.forEach(category => {
                    let findItem = element?.categories?.length && element.categories.filter(i=> i.categoryId.replaceAll("-", "") === category.id.replaceAll("-", ""));
                    if (findItem.length) {
                        discountPrice = discount;
                    }
                });
            }

            if (element.type === 'FIXED_PRODUCT' && element.valid) {
                let findItem = element?.items?.length && element.items.filter(i=> {
                    // Match by itemId and either skuCode is empty OR skuCode matches exactly OR starts with product code
                    if (i.itemId === itemIdValue) {
                        const discountItemSkuCode = i.skuCode || '';
                        const itemSkuCode = props.item.skuCode || props.item.code || '';
                        const itemCode = props.item.code || '';
                        // Match if discount skuCode is empty OR matches product's skuCode OR starts with product's code
                        return !discountItemSkuCode.length || discountItemSkuCode === itemSkuCode || discountItemSkuCode.startsWith(itemCode);
                    }
                    return false;
                });
                if (findItem.length) {
                    discountPrice = discount;
                    // Get skuLabel from matched discount item if available
                    if (findItem[0].skuLabel) {
                        matchedSkuLabel = findItem[0].skuLabel;
                    }
                }
            }
        });
    }

    return { discountPrice, skuLabel: matchedSkuLabel };
});

const total = computed(() => {
    let discountedPrice = 0;
    let salesPrice = 0;
    if (currenciesStore?.country?.currency != "BDT" &&
        currenciesStore?.country?.rate > 0
    ) {
        if (globalDiscount.value?.discountPrice > 0) {
            discountedPrice = (
                Number(globalDiscount.value.discountPrice) /
                Number(currenciesStore.country.rate)
            ).toFixed(2);
        }
        if (price.value > 0) {
            salesPrice = (
                Number(price.value) /
                Number(currenciesStore.country.rate)
            ).toFixed(2);
        }
    } else {
        if (globalDiscount.value?.discountPrice > 0) {
            discountedPrice = Number(globalDiscount.value.discountPrice);
        }
        if (price.value > 0) {
            salesPrice = Number(price.value);
        }
    }

    return {
        discountedPrice: discountedPrice,
        salesPrice: salesPrice,
    };
});

const itemCurrency = computed(() => {
    let currency = "BDT";
    if (
        currenciesStore.country &&
        currenciesStore.country.currency &&
        currenciesStore.country.currency.length > 0
    ) {
        currency = currenciesStore.country.currency;
    }

    return currency;
});

const convertPrice = (num) => {
    let val = 0;
    let currency = "BDT";
    if (
        currenciesStore.country &&
        currenciesStore.country.currency != "BDT" &&
        currenciesStore.country.rate > 0
    ) {
        if (num > 0) {
            val = Math.round((num / Number(currenciesStore.country.rate)).toFixed(2));
        }
        currency = currenciesStore.country.currency;
    } else {
        val = Math.round(num.toFixed(2));
    }
    return `${val}`;
};

const emiPrice = computed(() => {
    let emiPrice = 0;
    if (
        discountedSalesPrice.value > 0
    ) {
        emiPrice = discountedSalesPrice.value / 12;
    } else {
        emiPrice = price.value / 12;
    }

    return emiPrice;
});


const fetchAllDiscriminatorAttribute = async () => {
    const req = {
        page: 1,
        size: 50,
        textParams: [
            {
                field: "discriminator",
                value: false,
                matchType: "EXACT",
            },
        ],
    };
    let nextPageToken = "";
    do {
        let res = await optionsClient.search(req);
        if ((res.status = 200 && !res.networkError)) {
            if (res.body && res.body.list && res.body.list.length > 0) {
                let list = res.body.list.sort(
                    (x, y) => x.sortOrder - y.sortOrder
                );
                discriminatorAttribute.value =
                    discriminatorAttribute.value.concat(list);
            }
        }
    } while (nextPageToken != "");
};

const shakeAnimation = () => {
    shake.value = true;
    setTimeout(() => {
        shake.value = false;
    }, 500);
};

const convertDate = computed(() => {
    if (estTime.value?.length) {
        let splitDate = estTime.value.split(" ")[0];
        let someDate = new Date();
        let numberOfDaysToAdd = Number(splitDate);
        let result = someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
        let longStringDate = new Date(result).toLocaleString();

        return DateUtils.millisecondsToShortDateTime(longStringDate);
    }
    return "";
});

watch(
    selectedAttributeValues,
    () => {
        emit("selectImage", selectedAttributeValues.value);
    },
    { deep: true }
);

watch(()=>
    [total.value, itemCurrency.value],
    () => {
        let obj = {
            ...total.value,
            currency: itemCurrency.value
        }
        emit("update:modelValue", obj);
    },
    { deep: true }
);

watch(selectedOutlet, ()=> {
    if (selectedOutlet.value?.id?.length && selectedOutlet.value?.id != "Selected-One") {
        let obj = {
            division: selectedDivision.value?.name,
            outlets: selectedOutlet.value,
            estimatedTime: estTime.value,
        }
        localStorage.setItem("delivery-time", JSON.stringify(obj));
    }
},{deep: true, immediate: true});

onMounted(async () => {
    await fetchAllDiscriminatorAttribute();
});
</script>

<style lang="scss">
.active {
    border: 1px solid #f69320 !important;
    box-shadow: 0 1px 21px #e6e6e6;
    transition: all 0.2s ease-in-out;
    transform: scale(1.1);
}
.carousel__viewport {
    height: 100%;
    .carousel__track {
        height: 100%;
    }
}
.details-text-container {
    .accordion {
        .accordion-button:not(.collapsed) {
            color: var(--bs-accordion-active-color);
            background-color: white !important;
            box-shadow: none;
        }

        .accordion-button:focus {
            z-index: 3;
            border-color: transparent !important;
            outline: 0;
            box-shadow: none !important;
        }

        .accordion-item{
            // border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
            border: none !important;
            border-bottom: 2px solid rgba(0, 0, 0, 0.25) !important;
        }
    }
}

@keyframes shake {

    10%,
    90% {
        transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
        transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
        transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
        transform: translate3d(4px, 0, 0);
    }
}

.apply-shake {
    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

.special-leather {
    img {
        transition: all 0.2s ease-in-out;

        &:hover {
            transform: scale(1.1);
        }
    }
}

.special-fabric {
    width: 92%;
    right: -10px;
    background-color: #f9f7f3;
    box-shadow: -0.5rem 0rem 1rem 0rem rgba(0, 0, 0, 0.55) !important;
}

.special-fabric-item {
    right: 0px;
    width: 80% !important;
    height: auto !important;
    box-shadow: -0.5rem 0rem 1rem 0rem rgba(0, 0, 0, 0.55) !important;
}

.slide-right-enter-active {
    animation: slide-in-right 0.3s forwards;
    -webkit-animation: slide-in-right 0.3s forwards;
}

.slide-right-leave-active {
    animation: slide-out-right 0.3s forwards;
    -webkit-animation: slide-out-right 0.3s forwards;
}

@keyframes slide-in-right {
    0% {
        transform: translateX(100%);
    }

    100% {
        transform: translateX(0%);
    }
}

@keyframes slide-out-right {
    0% {
        transform: translateX(0%);
    }

    100% {
        transform: translateX(100%);
    }
}

.bg-image {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}


.emi-modal-content {
    position: relative;
    background-color: #fff;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border-radius: 6px;
    outline: 0;
}

.bankemis {
    .active {
          background: #6c757d;
        // background: #000;
        color: #fff;
        font-weight: 600;
        border: none !important;
    }
}

.modal-body {
    position: relative;
    padding: 15px;
}

.emi-wrappar {
    max-width: 100%;

    thead,
    tbody {
        border: 1px solid;
    }

    tr,
    td,
    th {
        font-weight: 600;
        border: 1px solid;
        text-align: center;
    }
}

.pd-list {
    margin-bottom: 10px;
}

.emi-wrappar h2 {
    text-transform: uppercase;
    text-align: center;
    font-size: 24px;
    line-height: 30px;
}

.bankemis {
    list-style: none;
    padding: 0;
}

.bankemis li {
    list-style: none;
    margin: 10px;
    display: inline-block;
    padding: 7px 15px;
    background: #f1f1f1;
    color: #000;
    cursor: pointer;
    font-weight: 600;
    border-radius: 5px;

}

.emi-msg {
    font-weight: bold;
    font-size: 18px;
}

.modal-footer {
    padding: 15px;
    text-align: right;
    border-top: 1px solid #e5e5e5;
}

.emi-wrappar.table-responsive {
    display: block;
}

.emi-wrappar {
    max-width: 100%;
}

.table-responsive {
    min-height: 0.01%;
    overflow-x: auto;
}
</style>
